/** Short link — fine for “open in new tab”; not the embed schedule id. */
const DEFAULT_BOOKING_URL = 'https://calendar.app.google/q97XyK9Yrmw9xieC8';

/**
 * Full appointment schedule URL from Google Calendar (use for embed).
 * Short links redirect here; the slug in calendar.app.google/… is not this id.
 */
const DEFAULT_EMBED_URL =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ30evlGLDANOFwNYCFxOG_RN-_sKX0FGSMDqxZdC0AsKOj8eIKjK1h7VhP_zVEeBBy-I76MJCl8';

/** Public booking page (opens in a new tab). */
export function googleCalendarBookingUrl(raw?: string): string {
  const url = (raw ?? DEFAULT_BOOKING_URL).trim().replace(/[\\/]+$/, '');
  return url || DEFAULT_BOOKING_URL;
}

function withEmbedMode(url: string): string {
  const parsed = new URL(url);
  parsed.searchParams.set('gv', 'true');
  return parsed.toString();
}

/**
 * Embed URL for Google Appointment Schedules (`gv=true` = website embed mode).
 * Prefer `REACT_APP_GOOGLE_CALENDAR_EMBED_URL` (full calendar.google.com/…/schedules/… URL).
 * @see https://support.google.com/calendar/answer/10733297
 */
export function googleCalendarEmbedUrl(bookingRaw?: string, embedRaw?: string): string {
  const embedCandidate = (embedRaw ?? '').trim().replace(/[\\/]+$/, '');
  if (embedCandidate) {
    return withEmbedMode(embedCandidate);
  }

  const booking = googleCalendarBookingUrl(bookingRaw);

  try {
    const parsed = new URL(booking);
    if (parsed.hostname === 'calendar.google.com' && parsed.pathname.includes('/appointments/schedules/')) {
      return withEmbedMode(booking);
    }
  } catch {
    /* fall through */
  }

  return withEmbedMode(DEFAULT_EMBED_URL);
}
